import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';
import { PreApprovedTemplateFilterModel, PreApprovedTemplateModel } from './PreApprovedTemplateModel';

@Service()
export default class PreApprovedTemplateService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async get(
        model: PreApprovedTemplateFilterModel,
        pageIndex: string,
        pageSize: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            let url = window.$config.HostName + 'api/pre-approved-template';

            const result = await this.axiosService.axiosInstance.get(url, {
                params: {
                    name: model.name,
                    pageIndex: pageIndex,
                    pageSize: pageSize,
                    classification: model.classification,
                    createdDateFrom: model.createdDateFrom,
                    createdDateTo: model.createdDateTo
                }
            });
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async getById(id: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/pre-approved-template/' + id;
            const response = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();

            return response.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async post(model: PreApprovedTemplateModel) {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/pre-approved-template';
            const payload = {
                Name: model.name,
                Description: model.description || '',
                TemplateContent: model.templateContent,
                Classification: model.classification,
            };
            const result = await this.axiosService.axiosInstance.post(url, payload);
            this.loaderService.HideLoader();
            return result.data;
        } catch (error) {
            this.loaderService.HideLoader();
            return error;
        }
    }

    public async activate(templateId: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/pre-approved-template/activate';
            const result = await this.axiosService.axiosInstance.get(url, {
                params: {
                    templateId: templateId
                }
            });
            this.loaderService.HideLoader();
            return result.data;
        } catch (error) {
            this.loaderService.HideLoader();
            return false;
        }
    }

}
